/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Recovery_Code_InstructionsInputs */



/**
* | output |
* | --- |
* | "Important Safety Instructions:" |
*
* @param {Auth_Recovery_Code_InstructionsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_recovery_code_instructions = /** @type {((inputs?: Auth_Recovery_Code_InstructionsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Recovery_Code_InstructionsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wichtige Sicherheitsanweisungen:")
	return /** @type {LocalizedString} */ ("Important Safety Instructions:")
});